import styled from "@emotion/styled"

export const StyledAboutUsWrapper = styled.div`
  margin: 3rem auto 0;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    max-width: ${(p) => p.theme.breakpoints.tablet};
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    max-width: ${(p) => p.theme.breakpoints.desktop};
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    max-width: ${(p) => p.theme.breakpoints.wide};
    margin: 5rem auto 0;
  }
`

export const StyledSectionDivider = styled.div`
  width: 100%;
  height: 0.0625rem;
  background: ${(p) => p.theme.colors.darkGrey};
  display: none;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    display: block;
  }
`

export const StyledAboutUsHero = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .bg-image {
    position: absolute;
    top: -0.375rem;
    z-index: -1;

    img {
      filter: brightness(0.6);
    }
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
  }
`

export const StyledAboutUsHeroTitle = styled.h6`
  color: ${(p) => p.theme.colors.white};
  font-family: ${(p) => p.theme.fontFamilies.headlineBig};
  font-style: ${(p) => p.theme.fontStyles.normal};
  font-weight: ${(p) => p.theme.fontWeights.liteBlack};
  letter-spacing: 0.02em;
  text-transform: uppercase;
  text-align: center;
  font-size: 0.625rem;
  line-height: 1rem;
  margin: 0 auto 0.5rem;
  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: 0.75rem;
    line-height: 1.25rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 1.5rem;
    line-height: 2rem;
  }
`
export const StyledAboutUsHeroText = styled.p`
  color: ${(p) => p.theme.colors.pitchBlack};
  font-family: ${(p) => p.theme.fontFamilies.headline};
  font-style: ${(p) => p.theme.fontStyles.normal};
  font-weight: ${(p) => p.theme.fontWeights.semiBolder};
  text-align: center;
  font-size: 24px;
  line-height: 34px;

  margin: 1rem 1rem 1.5rem;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: 32px;
    line-height: 44px;
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    margin: 2rem 1rem 1rem;
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 48px;
    line-height: 100%;
  }
`
export const StyledAboutUsHeroSubText = styled.p`
  color: ${(p) => p.theme.colors.pitchBlack};
  font-family: ${(p) => p.theme.fontFamilies.regular};
  font-style: ${(p) => p.theme.fontStyles.normal};
  font-weight: ${(p) => p.theme.fontWeights.liteMedium};
  text-align: center;

  font-size: 16px;
  line-height: 24px;

  margin: 0 1rem 1.5rem;

  a {
    color: ${(p) => p.theme.colors.blue};
    text-decoration: none;
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    margin: 0 1rem 2.5rem;
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 24px;
    line-height: 36px;
  }
`

export const StyledCoreWhatWeAreDoing = styled.section`
  padding: 1rem;
  background: ${(p) => p.theme.colors.whiteSmoke};
  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    padding-bottom: 2.5rem;
  }
`

export const StyledCoreWhatWeAreDoingTitle = styled.h2`
  font-family: ${(p) => p.theme.fontFamilies.headline};
  font-style: ${(p) => p.theme.fontStyles.normal};
  font-weight: ${(p) => p.theme.fontWeights.semiBolder};
  color: ${(p) => p.theme.colors.pitchBlack};
  font-size: 1.2rem;
  line-height: 1.5rem;
  text-align: center;
  margin: 1.5rem auto;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 2rem;
    line-height: 2.625rem;
    margin-top: 5rem;
  }
`

export const StyledCoreWhatWeAreDoingDivider = styled.div`
  width: 100%;
  height: 0.0625rem;
  background: ${(p) => p.theme.colors.darkGrey};
  margin: 1.5rem 0;
`

export const StyledCoreWhatWeAreDoingItems = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    flex-direction: row;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    flex-direction: row;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    flex-direction: row;
    margin-bottom: 5rem;
  }
`

export const StyledCoreWhatWeAreDoingItem = styled.div`
  margin-bottom: 1.875rem;
  font-size: 0.8rem;
  line-height: 1.1rem;
  display: flex;
  justify-content: start;
  margin-left: 0;
  margin-right: 0;

  .icon {
    color: ${(p) => p.theme.colors.blue};
    margin-right: 1rem;
    font-weight: ${(p) => p.theme.fontWeights.bold};
    font-size: 1.5rem;
    height: 1.5rem;
  }

  span {
    max-width: 100%;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    margin-bottom: 0;
    font-size: 1rem;
    line-height: 1.6rem;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;

    .icon {
      font-size: 2rem;
      height: 2rem;
    }

    span {
      max-width: 10.625rem;
    }
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    margin-bottom: 0;
    font-size: 1rem;
    line-height: 1.6rem;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;

    .icon {
      font-size: 2rem;
      height: 2rem;
    }

    span {
      max-width: 15.625rem;
    }
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    margin-bottom: 0;
    font-size: 1.7rem;
    line-height: 2.2rem;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;

    .icon {
      font-size: 2.5rem;
      height: 2.5rem;
    }

    span {
      max-width: 25rem;
    }
  }
`

export const StyledWhoAreWeHelping = styled.section`
  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    display: grid;
    grid-template-columns: 22.5rem auto;
    grid-template-areas: "text image";
    column-gap: 1rem;
    margin: 0 0 0 1.5rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    margin: 0 0 0 2rem;
    grid-template-columns: 29.125rem auto;
    column-gap: 2rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    margin: 0 6rem;
    grid-template-columns: 53.25rem auto;
    column-gap: 1.5rem;
  }
`

export const StyledWhoAreWeHelpingTextContainer = styled.div`
  grid-area: none;
  padding: 1rem;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    grid-area: text;
    padding: 0;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
  }
`

export const StyledWhoAreWeHelpingTitle = styled.h1`
  font-weight: ${(p) => p.theme.fontWeights.bold};
  font-size: 1.1rem;
  line-height: 1.5rem;
  margin-top: 1.875rem;
  margin-bottom: 1rem;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    font-size: 1.5rem;
    line-height: 2.2rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 2rem;
    line-height: 1.7rem;
    margin-top: 3rem;
    margin-bottom: 1.5rem;
  }
`

export const StyledWhoAreWeHelpingDescription = styled.p`
  font-size: 0.8rem;
  line-height: 1rem;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: 1rem;
    line-height: 1.4rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    font-size: 1rem;
    line-height: 1.4rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 1.5rem;
    line-height: 2.2rem;
  }
`

export const StyledWhoAreWeHelpingImageContainer = styled.div`
  img {
    width: 100%;
    height: auto;
  }
  grid-area: none;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    grid-area: image;
    img {
      width: auto;
      height: auto;
    }
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
  }
`

export const StyledWhoAreWeHelpingImages = styled.div`
  display: flex;
  justify-content: center;

  .image {
    height: 100%;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    justify-content: flex-end;

    .image {
      height: 100%;
    }
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    justify-content: flex-end;

    .image {
      max-width: 100%;
      height: 100%;
    }
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    justify-content: flex-end;

    .image {
      max-width: 100%;
      height: 100%;
    }
  }
`

export const StyledAboutSlice = styled.div`
  margin: 1.5rem 0;

  .media-box {
    align-items: start;
    margin-bottom: 2.4rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    display: grid;
    grid-template-columns: 22.5rem auto;
    column-gap: 1rem;
    margin: 2.5rem 1.5rem 1.5rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    margin: 2.5rem 2rem 1.5rem;
    grid-template-columns: 29.125rem auto;
    column-gap: 2rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    margin: 5rem 6rem 4rem;
    grid-template-columns: 53.25rem auto;
    column-gap: 1.5rem;
  }
`

export const StyledStats = styled.div`
  background: ${(p) => p.theme.colors.whiteSmoke};
  text-align: center;
  padding: 2.5rem 1.5rem 1.5rem;

  h4 {
    font-size: 1.125rem;
  }

  hr {
    margin: 1.5rem 0;
  }

  .counter {
    margin: 0;
    > div {
      padding: 0;
      margin-bottom: 1rem;
      min-width: 9.5rem;
    }
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    h4 {
      font-size: 1.5rem;
    }
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    span:last-of-type {
      font-size: 1.25rem;
    }
  }
`
export const StyledTextContainer = styled.div`
  margin: 1rem 1rem 2.5rem 1rem;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    margin: 0;
  }
`

export const StyledStoryTitle = styled.h2`
  font-weight: ${(p) => p.theme.fontWeights.bold};
  font-size: 1.1rem;
  line-height: 1.5rem;
  margin-bottom: 1rem;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 2rem;
    line-height: 2.6rem;
  }
`

export const StyledStoryDescription = styled.p`
  font-size: 0.8rem;
  line-height: 1.1rem;
  margin-bottom: 1rem;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: 1rem;
    line-height: 1.4rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    font-size: 1rem;
    line-height: 1.4rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 1.5rem;
    line-height: 2.2rem;
  }
`

// Pills/tags container
export const StyledFeatureTagsContainer = styled.div`
  background: ${(p) => p.theme.colors.white};
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  justify-content: center;
  min-height: 6.5rem;
  position: relative;

  margin: 0 -8rem 0 -6rem;
  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    max-width: 56rem;
    overflow-x: hidden;
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    max-width: 90rem;
  }
`

// Individual pill/tag
export const StyledFeatureTag = styled.span`
  background: ${(p) => p.theme.colors.white};
  border: 1px solid ${(p) => p.theme.colors.blue};
  color: ${(p) => p.theme.colors.pitchBlack};
  border-radius: 2rem;
  padding: 0.5rem 1.25rem;
  font-family: ${(p) => p.theme.fontFamilies.headline};
  font-weight: ${(p) => p.theme.fontWeights.semiBolder};
  font-size: 12px;
  margin-bottom: 0.5rem;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
  min-width: 220px;
  text-align: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  position: relative;
  line-height: 100%;
  letter-spacing: 4%;
  text-transform: uppercase;

  &:hover {
    background: ${(p) => p.theme.colors.blue};
    color: ${(p) => p.theme.colors.white};
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 16px;
  }
`

// Zapier integration code section
export const StyledZapierIntegrationSection = styled.section`
  background: ${(p) => p.theme.colors.whiteSmoke};
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 3rem 1rem;

  > div {
    display: block;
    max-width: initial;
    margin: 0 auto;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    padding: 3rem 2rem;
    > div {
      display: grid;
      grid-template-columns: 290px 1fr;
      gap: 3.5rem;
      align-items: center;
      max-width: initial;
      margin: 0 auto;
      max-width: 56rem;
      align-self: start;
    }
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    padding: 4rem 1rem;
    > div {
      max-width: 90rem;
    }
  }
`

export const StyledZapierPuzzleImage = styled.img`
  height: auto;
  display: block;
  width: 290px;
  margin: 0 auto 2.5rem;
  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    width: 300px;
    margin: 0 auto;
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    width: 300px;
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    width: 300px;
  }
`

export const StyledZapierIntegrationContent = styled.div`
  flex: 1;
`

export const StyledZapierIntegrationTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: ${(p) => p.theme.fontWeights.bold};
  margin-bottom: 1rem;
`

export const StyledZapierInfoBox = styled.div`
  background: ${(p) => p.theme.colors.white};
  padding: 0.75rem;
  border-radius: 4px;
  margin: 1.5rem 0;
  color: ${(p) => p.theme.colors.pitchBlack};
  font-size: 1rem;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-family: ${(p) => p.theme.fontFamilies.regular};
  font-weight: ${(p) => p.theme.fontWeights.normal};
  line-height: 1.5rem;


  svg {
    width: 1.5rem;
    height: 1.5rem;
    color: ${(p) => p.theme.colors.blue};
`

export const StyledZapierRegisterLinks = styled.div`
  margin-top: 1.5rem;
  font-size: 1rem;
  a {
    color: ${(p) => p.theme.colors.blue};
    text-decoration: underline;
    margin: 0 0.5rem;
  }
`

export const StyledBlurEdge = styled.div`
  display: none;
  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 11rem;
    z-index: 2;
    pointer-events: none;
    ${({ left, right, theme }) =>
      left
        ? `left: -0.5rem; background: linear-gradient(to right, ${theme.colors.white} 80%, transparent);`
        : right
        ? `right: -0.5rem; background: linear-gradient(to left, ${theme.colors.white} 80%, transparent);`
        : ""}
  }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    width: 25rem;
  }
`

export const StyledCodeLabel = styled.div`
  font-size: 0.95rem;
  font-weight: ${(p) => p.theme.fontWeights.bold};
  margin: 0 0 0.5rem;
  letter-spacing: 0.04em;
`

export const StyledCodeBox = styled.textarea`
  width: 100%;
  min-height: 70px;
  background: ${(p) => p.theme.colors.white};
  border: 1px solid ${(p) => p.theme.colors.darkGrey};
  border-radius: 0.4rem;
  font-size: 1rem;
  font-family: "Fira Mono", "Menlo", "Monaco", "Consolas", monospace;
  color: ${(p) => p.theme.colors.pitchBlack};
  padding: 0.7rem 1rem;
  resize: none;
  margin-bottom: 1.1rem;
  box-sizing: border-box;
`

export const StyledButtonRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 0.5rem;
`

export const StyledPrimaryButton = styled.button`
  background: ${(p) => p.theme.colors.blue};
  color: #fff;
  border: none;
  border-radius: 0.3rem;
  padding: 0.7rem 1.5rem;
  cursor: pointer;
  transition: background 0.2s;
  width: 100%;
  font-family: ${(p) => p.theme.fontFamilies.headline};
  font-weight: ${(p) => p.theme.fontWeights.semiBolder};
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 4%;
  text-align: center;
  text-transform: uppercase;

  &:hover {
    background: ${(p) => p.theme.colors.darkBlue || "#0077aa"};
  }
`

export const StyledSecondaryButton = styled.button`
  background: transparent;
  color: ${(p) => p.theme.colors.pitchBlack};
  border: 1.5px solid ${(p) => p.theme.colors.pitchBlack};
  border-radius: 0.3rem;
  padding: 0.7rem 1.5rem;
  font-weight: ${(p) => p.theme.fontWeights.bold};
  cursor: pointer;
  transition: background 0.2s, color 0.2s;

  font-family: ${(p) => p.theme.fontFamilies.headline};
  font-weight: ${(p) => p.theme.fontWeights.semiBolder};
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 4%;
  text-transform: uppercase;

  &:hover {
    background: ${(p) => p.theme.colors.blue};
    color: #fff;
  }
`
